import { FaDownload, FaEye } from "react-icons/fa";


const RESUME_PREVIEW = "https://drive.google.com/file/d/1_YwtK4hWx0mXHxrD4uwtgy1Q3vrpqQq1/view?usp=sharing";
const RESUME_DOWNLOAD = "https://drive.google.com/uc?export=download&id=1_YwtK4hWx0mXHxrD4uwtgy1Q3vrpqQq1";
const highlights = [
  "B.Sc. Computer Science",
  "Full-Stack Development",
  "Mobile Apps (Android & iOS)",
  "REST API Design",
  "ICT Training & Curriculum",
  "Firebase & Cloud Services",
];

export default function Resume() {
  return (
    <section id="resume" className="bg-navy-900 section-padding">
      <div className="container-max">
        <div className="text-center mb-14">
          <span className="section-tag">My Credentials</span>
          <h2 className="section-title">Resume</h2>
          <p className="section-sub">
            Download or preview my full resume for a detailed look at my background.
          </p>
        </div>

        <div className="max-w-2xl mx-auto card text-center hover:shadow-glow transition-all">
          {/* Icon */}
          <div className="w-16 h-16 bg-cyan-500/10 border border-cyan-500/20 rounded-2xl
                          flex items-center justify-center mx-auto mb-6">
            <FaDownload size={26} className="text-cyan-400" />
          </div>

          <h3 className="font-bold text-xl text-white mb-1">Nakarda Richards - Resume</h3>
          <p className="text-sm text-slate-400 mb-7">
            Software Developer &nbsp;·&nbsp; Mobile &amp; Web Apps &nbsp;·&nbsp; REST APIs &nbsp;·&nbsp; ICT Instructor
          </p>


          {/* Highlight pills */}
          <div className="flex flex-wrap gap-2 justify-center mb-8">
            {highlights.map((h) => (
              <span key={h}
                className="bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs font-medium px-3 py-1 rounded-full">
                {h}
              </span>
            ))}
          </div>

          {/* Buttons */}
 
<div className="flex flex-wrap gap-4 justify-center">
  <a href={RESUME_DOWNLOAD} className="btn-primary flex items-center gap-2">
    <FaDownload size={13} /> Download PDF
  </a>
  <a href={RESUME_PREVIEW} target="_blank" rel="noreferrer" className="btn-outline flex items-center gap-2">
    <FaEye size={13} /> Preview Online
  </a>
</div>
          <p className="text-xs text-slate-600 mt-6">PDF format</p>
        </div>
      </div>
    </section>
  );
}